class CollectionBannerSEO {
  constructor() {
    this.init();
  }

  init() {
    const seoWrapper = document.querySelector('[data-seo-wrapper]');
    const seoContent = document.querySelector('[data-seo-content]');
    const seoToggle = document.querySelector('[data-seo-toggle]');
    const seoToggleText = document.querySelector('[data-seo-toggle-text]');

    if (!seoWrapper || !seoContent || !seoToggle || !seoToggleText) {
      return;
    }

    // Vérifier si le contenu dépasse la hauteur maximale (9em)
    const checkIfNeedsToggle = () => {
      // Réinitialiser pour mesurer
      seoWrapper.removeAttribute('data-expanded');
      seoWrapper.removeAttribute('data-has-toggle');
      
      // Forcer le reflow
      void seoContent.offsetHeight;
      
      // Obtenir la hauteur réelle du contenu
      const contentHeight = seoContent.scrollHeight;
      const maxHeight = parseFloat(window.getComputedStyle(seoContent).maxHeight);
      
      // Si la hauteur dépasse 9em, afficher le bouton
      if (contentHeight > maxHeight + 2) {
        seoWrapper.setAttribute('data-has-toggle', 'true');
        return true;
      } else {
        seoWrapper.removeAttribute('data-has-toggle');
        return false;
      }
    };

    // Vérifier au chargement
    const needsToggle = checkIfNeedsToggle();

    if (!needsToggle) {
      return;
    }

    // Gérer le clic sur le bouton
    seoToggle.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      
      const isExpanded = seoWrapper.getAttribute('data-expanded') === 'true';
      
      if (isExpanded) {
        // Réduire
        seoWrapper.removeAttribute('data-expanded');
        seoToggleText.textContent = 'Lire plus';
        seoToggle.setAttribute('aria-expanded', 'false');
      } else {
        // Étendre
        seoWrapper.setAttribute('data-expanded', 'true');
        seoToggleText.textContent = 'Lire moins';
        seoToggle.setAttribute('aria-expanded', 'true');
      }
    });

    // Re-vérifier au redimensionnement de la fenêtre
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        checkIfNeedsToggle();
      }, 250);
    });
  }
}

// Initialiser quand le DOM est prêt
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new CollectionBannerSEO();
  });
} else {
  new CollectionBannerSEO();
}
